import { signal } from '@preact/signals';
import type { DeathView, HudAction, HudView, ResultView } from './env';

/** UI state of the current instance (refreshed a few times a second by the client system). */
export const instUi = {
  hud: signal<HudView | null>(null),
  death: signal<DeathView | null>(null),
  result: signal<ResultView | null>(null),
};

let handler: (id: string) => void = () => {};

/** Installed by the client: routes HUD buttons to the active script. */
export function setActionHandler(fn: (id: string) => void): void {
  handler = fn;
}

export function runAction(a: HudAction, confirm: (text: string, ok: () => void) => void): void {
  if (a.disabled) return;
  if (a.confirm) confirm(a.confirm, () => handler(a.id));
  else handler(a.id);
}
